/* ==========================================================================
   Lovelle — lift.js (Lovelle Lift bamboo support socks, product.lift.json)
   Loaded only on that template, after bra.js (both deferred, in that order).
   bra.js already owns the packs, the per-pair <select>s, the hidden size
   pills, the add-to-cart, reviews and the lightbox. This adds:

   1. The packs and pairs are bra.js's (tier switch, per-pair design and
      size dropdowns, gallery move, add to cart). This keeps pair N the same
      in every pack, so switching pack keeps her choices, and the first size
      she picks fills every pair that has none yet.
   2. Before bra.js adds anything: every pair in the chosen pack needs a
      size; a missing one is pointed at, not guessed.
   3. The sticky bar follows the chosen pack (name + total) and adds it.
   4. Size guide dialog with the shoe-size calculator (EU, or UK under 20);
      its answer goes on every pair.
   5. Design cards further down (All / Solid / Pattern tabs, "Välj …" puts
      that design on every pair), the numbered detail photo and in-page
      links under the sticky header.

   No user-facing string is written here; every word is already in the DOM.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-lf-root]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function headerOffset() {
    var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10);
    return (isNaN(h) ? 64 : h) + 14;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  }

  /* ---- 7: in-page links (stars under the title, "see all reviews") ---- */
  qsa('[data-lf-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = qs(a.getAttribute('data-lf-scroll'));
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('data-lf-scroll'));
    });
  });

  /* ---- 7: photo with numbered details ---- */
  qsa('[data-lf-spots]').forEach(function (box) {
    var dots = qsa('[data-lf-spot]', box);
    var panels = qsa('[data-lf-spot-panel]', box);
    if (!dots.length) return;
    function show(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    box.classList.add('is-ready');
  });

  /* ---- 6: size guide dialog + calculator (works on every section) ---- */
  var guide = qs('[data-lf-guide]');
  var lastOpener = null;
  function openGuide(opener) {
    if (!guide) return;
    lastOpener = opener || null;
    if (typeof guide.showModal === 'function') { if (!guide.open) guide.showModal(); }
    else guide.setAttribute('open', '');
    document.documentElement.classList.add('lf-guide-open');
  }
  function closeGuide() {
    if (!guide) return;
    guide.classList.add('is-closing');
    setTimeout(function () {
      guide.classList.remove('is-closing');
      if (typeof guide.close === 'function' && guide.open) guide.close();
      else guide.removeAttribute('open');
      document.documentElement.classList.remove('lf-guide-open');
      if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
    }, reduced ? 0 : 200);
  }
  qsa('[data-lf-guide-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openGuide(b); });
  });
  if (guide) {
    qsa('[data-lf-guide-close]', guide).forEach(function (b) { b.addEventListener('click', closeGuide); });
    guide.addEventListener('click', function (e) { if (e.target === guide) closeGuide(); });
    guide.addEventListener('cancel', function (e) { e.preventDefault(); closeGuide(); });
  }

  /* The chart (snippets/lift-size-chart), by shoe size, the larger size when
     in between: EU under 38 S/M · 38–41½ L/XL · 42+ 2XL; UK (any number under
     20) under 5 S/M · 5–7 L/XL · 7½+ 2XL. */
  function sizeFor(shoe) {
    if (!shoe) return null;
    if (shoe < 20) {
      if (shoe < 1 || shoe > 13) return null;
      return shoe < 5 ? 'S/M' : shoe < 7.5 ? 'L/XL' : '2XL';
    }
    if (shoe < 33 || shoe > 48) return null;
    return shoe < 38 ? 'S/M' : shoe < 42 ? 'L/XL' : '2XL';
  }
  qsa('[data-lf-calc]').forEach(function (form) {
    var shoe = qs('[data-lf-shoe]', form);
    var res = qs('[data-lf-calc-res]', form);
    var sizeEl = qs('[data-lf-calc-size]', form);
    var use = qs('[data-lf-calc-use]', form);
    var msg = qs('[data-lf-calc-msg]', form);
    var chart = form.parentNode;
    var current = null;
    function mark(s) {
      qsa('[data-lf-row]', chart).forEach(function (r) { r.classList.toggle('is-match', r.getAttribute('data-lf-row') === s); });
    }
    function run() {
      var b = parseFloat(String(shoe.value).replace(',', '.'));
      current = null;
      if (!b) {
        res.hidden = true; use.hidden = true; mark(null);
        msg.textContent = shoe.value ? form.getAttribute('data-msg-empty') : '';
        msg.hidden = !msg.textContent;
        return;
      }
      var s = sizeFor(b);
      if (!s) {
        res.hidden = true; use.hidden = true; mark(null);
        msg.textContent = form.getAttribute('data-msg-out');
        msg.hidden = false;
        return;
      }
      current = s;
      msg.hidden = true;
      sizeEl.textContent = s;
      res.hidden = false;
      res.classList.remove('is-new'); void res.offsetWidth; res.classList.add('is-new');
      mark(s);
      if (window.LiftSetSize) {
        use.textContent = (form.getAttribute('data-use') || '').replace('[size]', s);
        use.hidden = false;
      }
    }
    form.addEventListener('input', run);
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    use.addEventListener('click', function () {
      if (!current || !window.LiftSetSize) return;
      window.LiftSetSize(current);
      if (guide && guide.contains(form)) closeGuide();
      setTimeout(function () {
        var block = qs('[data-lf-bundle] .is-selected') || qs('[data-lf-bundle]');
        scrollToEl(block);
        flash(block);
      }, reduced ? 0 : 220);
    });
  });

  /* ---- 7: All / Solid / Pattern tabs over the design cards (no buy box needed) ---- */
  qsa('[data-lf-colours]').forEach(function (sec) {
    var tabs = qsa('[data-lf-group]', sec);
    var cards = qsa('[data-lf-card]', sec);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var g = t.getAttribute('data-lf-group');
        tabs.forEach(function (o) { var on = o === t; o.classList.toggle('is-active', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var show = g === 'all' || c.getAttribute('data-lf-card') === g;
          if (show && c.hidden) { c.hidden = false; c.classList.remove('is-in'); void c.offsetWidth; c.classList.add('is-in'); }
          else if (!show) c.hidden = true;
        });
      });
    });
  });

  if (!root) return;
  var bundle = qs('[data-lf-bundle]', root);
  if (!bundle) return;
  var tierInputs = qsa('input[data-bra-tier]', bundle);
  var errEl = qs('[data-bra-err]', bundle);
  var addBtn = qs('[data-bra-add]', bundle);

  function selectedBox() {
    var cur = qs('input[data-bra-tier]:checked', bundle);
    return cur ? cur.closest('[data-bra-tier-box]') : null;
  }
  function setSelect(sel, value) {
    if (!sel || sel.value === value) return;
    if (sel.__bra) sel.__bra.set(value, true); else sel.value = value;
  }

  /* ---- Keep pair N the same in every pack (switching pack keeps her choices) ---- */
  var syncing = false;
  function mirror(src) {
    if (syncing) return;
    var pick = src.closest('[data-bra-pick]');
    if (!pick) return;
    var i = pick.getAttribute('data-index');
    var isSize = src.hasAttribute('data-bra-size');
    syncing = true;
    qsa('[data-bra-pick][data-index="' + i + '"] select[' + (isSize ? 'data-bra-size' : 'data-bra-color') + ']', bundle).forEach(function (s) {
      if (s !== src) setSelect(s, src.value);
    });
    // The first size she picks goes on every pair that has none yet.
    if (isSize && src.value) {
      qsa('select[data-bra-size]', bundle).forEach(function (s) { if (!s.value) setSelect(s, src.value); });
    }
    syncing = false;
    paintMissing();
    paintAllSizes();
  }

  /* ---- Size dropdowns: a readable "Välj storlek" until a size is chosen ----
     bra.js draws the button from the select's value, so an empty value would
     leave a blank box and list the placeholder as a struck-out choice. The
     placeholder row is hidden from the menu and painted on the button instead. */
  function paintSizePlaceholder(sel) {
    var wrap = sel.nextElementSibling;
    if (!wrap || !wrap.classList || !wrap.classList.contains('brasel')) return;
    var ph = qs('.brasel__opt[data-value=""]', wrap);
    if (ph) ph.hidden = true;
    if (sel.value) { wrap.classList.remove('is-empty'); return; }
    var btn = qs('.brasel__btn', wrap);
    var text = sel.options[0] ? sel.options[0].textContent : '';
    if (btn) btn.innerHTML = '<span class="brasel__cur"><span class="brasel__ph">' + text.replace(/[<>&]/g, '') + '</span></span><span class="brasel__caret"></span>';
    wrap.classList.add('is-empty');
  }
  function paintAllSizes() { qsa('select[data-bra-size]', bundle).forEach(paintSizePlaceholder); }
  paintAllSizes();

  /* ---- Design dropdowns: clean thumbnails of the whole pair ----
     bra.js draws its chips from the variant photo (crossed legs, zoomed in);
     every option carries its own small square photo (data-swatch, the front
     shot of that design), which replaces the chip in the button and the menu. */
  var swatchOf = {};
  qsa('select[data-bra-color] option', bundle).forEach(function (o) { if (o.getAttribute('data-swatch')) swatchOf[o.value] = o.getAttribute('data-swatch'); });
  function paintChips(wrap, sel) {
    qsa('.brasel__opt', wrap).forEach(function (o) {
      var i = qs('.brasel__sw', o); var u = swatchOf[o.getAttribute('data-value')];
      if (i && u) { i.className = 'brasel__sw brasel__sw--photo'; i.style.backgroundImage = 'url(' + u + ')'; }
    });
    var cur = qs('.brasel__btn .brasel__sw', wrap); var u2 = swatchOf[sel.value];
    if (cur && u2 && cur.style.backgroundImage.indexOf(u2) < 0) { cur.className = 'brasel__sw brasel__sw--photo'; cur.style.backgroundImage = 'url(' + u2 + ')'; }
  }
  qsa('select[data-bra-color]', bundle).forEach(function (sel) {
    var wrap = sel.nextElementSibling;
    if (!wrap || !wrap.classList || !wrap.classList.contains('brasel')) return;
    paintChips(wrap, sel);
    var btn = qs('.brasel__btn', wrap);
    if (btn && 'MutationObserver' in window) new MutationObserver(function () { paintChips(wrap, sel); }).observe(btn, { childList: true });
  });

  function paintMissing() {
    qsa('[data-bra-pick]', bundle).forEach(function (p) {
      var s = qs('select[data-bra-size]', p);
      p.classList.toggle('is-nosize', !!s && !s.value);
    });
  }

  bundle.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-bra-size], select[data-bra-color]')) {
      mirror(t);
      if (errEl && t.matches('select[data-bra-size]')) errEl.hidden = true;
      return;
    }
    if (t.matches('input[data-bra-tier]')) { paintSticky(t, true); }
  });

  /* ---- Ask for a missing size before bra.js adds anything ---- */
  function firstMissing() {
    var box = selectedBox();
    if (!box) return null;
    return qsa('[data-bra-pick]', box).filter(function (p) {
      var s = qs('select[data-bra-size]', p);
      return s && !s.value;
    })[0] || null;
  }
  function askForSize(pick) {
    if (errEl) {
      errEl.textContent = (bundle.getAttribute('data-msg-size') || '').replace('[n]', pick.getAttribute('data-index'));
      errEl.hidden = false;
    }
    pick.classList.remove('is-flash'); void pick.offsetWidth; pick.classList.add('is-flash');
    scrollToEl(pick);
    var btn = qs('[data-bra-pick-size] .brasel__btn', pick) || qs('select[data-bra-size]', pick);
    if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, reduced ? 0 : 450);
  }
  bundle.addEventListener('click', function (e) {
    var hit = e.target && e.target.closest ? e.target.closest('[data-bra-add]') : null;
    if (!hit) return;
    var miss = firstMissing();
    if (!miss) return;
    e.preventDefault();
    e.stopPropagation();
    askForSize(miss);
  }, true);

  /* ---- The sticky bar follows the chosen pack ---- */
  var sticky = qs('[data-lf-sticky]', root);
  var stickyName = sticky ? qs('[data-lf-sticky-name]', sticky) : null;
  var stickyTotal = sticky ? qs('[data-lf-sticky-total]', sticky) : null;
  var stickyBuy = sticky ? qs('[data-lf-sticky-buy]', sticky) : null;
  function bump(el) {
    if (!el || reduced) return;
    el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
  }
  function paintSticky(input, animate) {
    if (!input) return;
    if (stickyName) stickyName.textContent = input.getAttribute('data-name') || stickyName.textContent;
    if (stickyTotal) stickyTotal.textContent = input.getAttribute('data-total') || stickyTotal.textContent;
    if (animate) { bump(stickyTotal); bump(qs('[data-bra-total]', bundle)); }
  }
  paintSticky(qs('input[data-bra-tier]:checked', bundle), false);
  if (stickyBuy) stickyBuy.addEventListener('click', function () {
    var miss = firstMissing();
    if (miss) { askForSize(miss); return; }
    if (addBtn) addBtn.click();
  });

  /* ---- "Välj [design]" cards further down: that design on every pair ---- */
  qsa('[data-lf-pick-colour]').forEach(function (b) {
    b.addEventListener('click', function () {
      var value = b.getAttribute('data-value');
      if (!value) return;
      syncing = true;
      qsa('select[data-bra-color]', bundle).forEach(function (s) { setSelect(s, value); });
      syncing = false;
      if (window.LovelleShowSlide) {
        var first = qs('select[data-bra-color]', bundle);
        var match = first ? Array.prototype.filter.call(first.options, function (o) { return o.value === value; })[0] : null;
        // data-pos = the design's position in Shopify (the dropdown may be reordered)
        var idx = match ? (parseInt(match.getAttribute('data-pos'), 10) || (Array.prototype.indexOf.call(first.options, match) + 1)) - 1 : -1;
        var per = parseInt(bundle.getAttribute('data-per-colour'), 10) || 3;
        if (idx > -1) window.LovelleShowSlide(idx * per);
      }
      var box = selectedBox() || bundle;
      scrollToEl(box);
      flash(box);
    });
  });

  /* The size guide's answer goes on every pair. */
  window.LiftSetSize = function (s) {
    syncing = true;
    qsa('select[data-bra-size]', bundle).forEach(function (sel) {
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value.toLowerCase() === String(s).toLowerCase(); })[0];
      if (opt) setSelect(sel, opt.value);
    });
    syncing = false;
    if (errEl) errEl.hidden = true;
    paintMissing();
    paintAllSizes();
  };

  /* Open the gallery on the starting design (the first one in the dropdown order). */
  var startSlide = parseInt(bundle.getAttribute('data-lf-start-slide'), 10) || 0;
  if (startSlide > 0 && typeof window.LovelleShowSlide === 'function') {
    window.LovelleShowSlide(startSlide);
    var lfThumbs = document.querySelector('[data-lf-thumbs]');
    var activeThumb = lfThumbs ? lfThumbs.querySelector('button.is-active') : null;
    if (activeThumb && lfThumbs.scrollTo) lfThumbs.scrollTo({ left: activeThumb.offsetLeft - 8, behavior: 'auto' });
  }

  paintMissing();
  if (!tierInputs.length) return;
})();
